import { accountsActions, userActions } from '@modules';
import { globalActions } from '@modules/global';
import { loginActions } from '@modules/login';
import { TMiddleware } from '@modules/types';
import { withdrawActions } from '@modules/withdraw';

import { checkActionsType } from './utils';

export const setCaptcha: TMiddleware = store => next => action => {
  const isShowCaptcha = action.payload?.data?.captcha;
  const actions = [
    loginActions.login.rejected,
    loginActions.resendVerification.rejected,
    loginActions.resetPasswordPhone.rejected,
    userActions.changePassword.rejected,
    userActions.changePhone.rejected,
    userActions.changeEmailSendOldEmail.rejected,
    userActions.changeEmailSendNewEmail.rejected,
    accountsActions.accountWithdraw.rejected,
    withdrawActions.withdrawResendVerification.rejected,
    accountsActions.accountWithdrawVerifyResend.rejected,
  ];
  if (isShowCaptcha && checkActionsType(action, actions)) {
    store.dispatch(globalActions.setShowCaptcha(true));
  }

  return next(action);
};

export default setCaptcha;
